import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";
import PageLayout from "../PageLayout";
import { useForm, useController, Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { toast } from "react-toastify";
import { createPublicationApi } from "src/network/api";
import { useNavigate } from "react-router-dom";

const AddPublication = () => {
  const [publication, setPublication] = useState({
    journal_name:"",
    paper_title: "",
    publication_year: "",
    paper_type: "Journal",
    authors: "",
    issn: "",
    volume: "",
    issue: "",
    live_url: "",
    indexing_with: [],
    publication_date: "",
    description: "",
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    control,
  } = useForm();

  const [loading, setIsLoading] = useState(false);

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setPublication((prevState) => ({
      ...prevState,
      indexing_with: checked
        ? [...prevState.indexing_with, value] // Add value if checked
        : prevState.indexing_with.filter((item) => item !== value), // Remove value if unchecked
    }));
  };

  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      // Include `indexing_with` from state
      const payload = { ...data, indexing_with: publication.indexing_with };
      let response = await createPublicationApi(payload);
      console.log(payload);
      if (response.status === 200 && response.data.status === 200) {
        toast.success(response.data.message);
        reset(); // Reset the form
      } else {
        toast.error(response.data.message);
      }
    } catch (e) {
      console.error(e);
      toast.error(e.response?.data?.message ?? e.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PageLayout>
      <Container className="mt-5 mb-5">
        <Row className="justify-content-center">
          <Col md="10" sm="12">
            <Card className="shadow-lg border-0 rounded-lg">
              <CardBody>
                <CardTitle
                  tag="h4"
                  className="text-center text-primary font-weight-bold mb-4"
                >
                  Add a New Publication
                </CardTitle>
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <FormGroup>
                    <Label
                      for="paper_title"
                      className="text-dark font-weight-bold"
                    >
                      Journal name<span className="text-danger">*</span>
                    </Label>
                    <input
                      type="text"
                      placeholder="Enter the title of the paper"
                      className={
                        "form-control" +
                        (!errors.journal_name ? "" : " danger-border")
                      }
                      {...register("journal_name", {
                        required: "This field is required",
                        value: publication.journal_name,
                        // pattern: {
                        //   value: /^[a-zA-Z\s]+$/,
                        //   message: "Invalid value entered ",
                        // },
                      })}
                    />
                    <p className="error-text">
                      <ErrorMessage errors={errors} name="journal_name" />
                    </p>
                  </FormGroup>
                  {/* Title */}
                  {/* <FormGroup>
                    <Label
                      for="journal_name"
                      className="text-dark font-weight-bold"
                    >
                      Journal Name<span className="text-danger">*</span>
                    </Label>
                    <input
                      type="text"
                      placeholder="Enter the journal name"
                      className={
                        "form-control" +
                        (!errors.journal_name ? "" : " danger-border")
                      }
                      {...register("paper_title", {
                        required: "This field is required",
                        value: publication.journal_name,
                        // pattern: {
                        //   value: /^[a-zA-Z\s]+$/,
                        //   message: "Invalid value entered ",
                        // },
                      })}
                    />
                    <p className="error-text">
                      <ErrorMessage errors={errors} name="paper_title" />
                    </p>
                  </FormGroup> */}
                  <FormGroup>
                    <Label
                      for="paper_title"
                      className="text-dark font-weight-bold"
                    >
                      Title<span className="text-danger">*</span>
                    </Label>
                    <input
                      type="text"
                      placeholder="Enter the title of the paper"
                      className={
                        "form-control" +
                        (!errors.paper_title ? "" : " danger-border")
                      }
                      {...register("paper_title", {
                        required: "This field is required",
                        value: publication.paper_title,
                        // pattern: {
                        //   value: /^[a-zA-Z\s]+$/,
                        //   message: "Invalid value entered ",
                        // },
                      })}
                    />
                    <p className="error-text">
                      <ErrorMessage errors={errors} name="paper_title" />
                    </p>
                  </FormGroup>

                  {/* Authors */}
                  <FormGroup>
                    <Label for="authors" className="text-dark font-weight-bold">
                      Authors<span className="text-danger">*</span>
                    </Label>
                    <input
                      type="text"
                      placeholder="Enter the author of the paper"
                      className={
                        "form-control" +
                        (!errors.authors ? "" : " danger-border")
                      }
                      {...register("authors", {
                        required: "This field is required",
                        value: publication.authors,
                        // pattern: {
                        //   value: /^[a-zA-Z\s]+$/,
                        //   message: "Invalid value entered ",
                        // },
                      })}
                    />
                    <p className="error-text">
                      <ErrorMessage errors={errors} name="authors" />
                    </p>
                  </FormGroup>
                  {/* Publication Year */}
                  <FormGroup>
                    <Label
                      for="publication_year"
                      className="text-dark font-weight-bold"
                    >
                      Publication Year<span className="text-danger">*</span>
                    </Label>
                    <input
                      type="text"
                      placeholder="Enter the publication year"
                      className={
                        "form-control" +
                        (!errors.publication_year ? "" : " danger-border")
                      }
                      {...register("publication_year", {
                        required: "This field is required",
                        value: publication.publication_year,
                        pattern: {
                          value: /^(19|20)\d{2}$/,

                          message: "Invalid year entered",
                        },
                      })}
                    />
                    <p className="error-text">
                      <ErrorMessage errors={errors} name="publication_year" />
                    </p>
                  </FormGroup>

                  {/* Publication Type */}
                  <FormGroup tag="fieldset">
                    <Label
                      for="paper_type"
                      className="text-dark font-weight-bold"
                    >
                      Publication Type<span className="text-danger">*</span>
                    </Label>
                    <div className="d-flex align-items-center">
                      <FormGroup check className="mr-3">
                        <Label check>
                          <Controller
                            name="paper_type"
                            control={control}
                            defaultValue="Journal"
                            render={({ field }) => (
                              <Input
                                {...field}
                                type="radio"
                                value="Journal"
                                checked={field.value === "Journal"}
                              />
                            )}
                          />
                          Journal
                        </Label>
                      </FormGroup>

                      <FormGroup check className="mr-3">
                        <Label check>
                          <Controller
                            name="paper_type"
                            control={control}
                            defaultValue="Journal"
                            render={({ field }) => (
                              <Input
                                {...field}
                                type="radio"
                                value="Patent"
                                checked={field.value === "Patent"}
                              />
                            )}
                          />
                          Patent
                        </Label>
                      </FormGroup>

                      <FormGroup check>
                        <Label check>
                          <Controller
                            name="paper_type"
                            control={control}
                            defaultValue="Journal"
                            render={({ field }) => (
                              <Input
                                {...field}
                                type="radio"
                                value="Book"
                                checked={field.value === "Book"}
                              />
                            )}
                          />
                          Book
                        </Label>
                      </FormGroup>
                    </div>

                    {/* ISSN/P-ISSN/ISBN */}
                    <FormGroup>
                      <Label
                        for="issn"
                        className="text-dark font-weight-bold mt-3"
                      >
                        ISSN/P-ISSN/ISBN<span className="text-danger">*</span>
                      </Label>
                      <input
                        type="text"
                        placeholder="Enter the ISSN/P-ISSN/ISBN"
                        className={
                          "form-control" +
                          (!errors.issn ? "" : " danger-border")
                        }
                        {...register("issn", {
                          required: "This field is required",
                          value: publication.issn,
                          pattern: {
                            value: /^[0-9-]+$/,
                            message: "Invalid value entered",
                          },
                        })}
                      />
                      <p className="error-text">
                        <ErrorMessage errors={errors} name="issn" />
                      </p>
                    </FormGroup>

                    {/* Volume */}

                    <FormGroup>
                      <Label
                        for="volume"
                        className="text-dark font-weight-bold"
                      >
                        Volume<span className="text-danger">*</span>
                      </Label>
                      <input
                        type="text"
                        placeholder="Enter the volume"
                        className={
                          "form-control" +
                          (!errors.volume ? "" : " danger-border")
                        }
                        {...register("volume", {
                          required: "This field is required",
                          value: publication.volume,
                          pattern: {
                            value: /^[0-9]+$/,
                            message: "Invalid value entered",
                          },
                        })}
                      />
                      <p className="error-text">
                        <ErrorMessage errors={errors} name="volume" />
                      </p>
                    </FormGroup>

                    {/* Issue */}
                    <FormGroup>
                      <Label for="issue" className="text-dark font-weight-bold">
                        Issue<span className="text-danger">*</span>
                      </Label>
                      <input
                        type="text"
                        placeholder="Enter the issue number"
                        className={
                          "form-control" +
                          (!errors.issue ? "" : " danger-border")
                        }
                        {...register("issue", {
                          required: "This field is required",
                          value: publication.issue,
                          pattern: {
                            value: /^[0-9]+$/,
                            message: "Invalid value entered",
                          },
                        })}
                      />
                      <p className="error-text">
                        <ErrorMessage errors={errors} name="issue" />
                      </p>
                    </FormGroup>

                    {/* Indexing With */}
                    <FormGroup>
                      <Label
                        for="indexing_with"
                        className="text-dark font-weight-bold"
                      >
                        Indexing With
                      </Label>
                      <div className="d-flex flex-wrap align-items-center">
                        {[
                          "SCOPUS",
                          "SSCI",
                          "ESCI",
                          "Thomson Reuters",
                          "SCI-E",
                          "UGC-CARE",
                          "NAAS",
                          "ABCD Index",
                        ].map((indexing) => (
                          <FormGroup check className="mr-3" key={indexing}>
                            <Label check>
                              <Input
                                type="checkbox"
                                name="indexing_with"
                                value={indexing}
                                checked={publication.indexing_with.includes(
                                  indexing
                                )}
                                onChange={handleCheckboxChange}
                              />
                              {indexing}
                            </Label>
                          </FormGroup>
                        ))}
                      </div>
                    </FormGroup>

                    <FormGroup>
                      <Label
                        for="description"
                        className="text-dark font-weight-bold"
                      >
                        Description/Abstract
                      </Label>
                      <textarea
                        placeholder="Enter the description/abstract"
                        className="form-control"
                        {...register("description")}
                      />
                    </FormGroup>

                    {/* Live Link */}
                    <FormGroup>
                      <Label
                        for="live_url"
                        className="text-dark font-weight-bold"
                      >
                        Live Link
                      </Label>
                      <input
                        type="text"
                        placeholder="Enter the live link"
                        className="form-control"
                        {...register("live_url")}
                      />
                    </FormGroup>

                    {/* Date */}
                    <FormGroup>
                      <Label
                        for="publication_date"
                        className="text-dark font-weight-bold"
                      >
                        Publication Date
                      </Label>
                      <input
                        type="date"
                        className="form-control"
                        {...register("publication_date")}
                      />
                    </FormGroup>
                  </FormGroup>
                  {/* Submit Button */}
                  <div className="mt-4">
                    {loading ? (
                      <Button
                        color="primary"
                        className="btn-block"
                        type="submit"
                        disabled
                      >
                        Submitting ...
                      </Button>
                    ) : (
                      <Button
                        color="primary"
                        className="btn-block"
                        type="submit"
                      >
                        Add Publication
                      </Button>
                    )}
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </PageLayout>
  );
};

export default AddPublication;
